export default {
  "color": {
    "bg": "var(--color-bg)",
    "bgAssistive": "var(--color-bg-assistive)",
    "bgAssistiveHover": "var(--color-bg-assistive-hover)",
    "bgAssistivePressed": "var(--color-bg-assistive-pressed)",
    "bgAssistiveSecondary": "var(--color-bg-assistive-secondary)",
    "bgAssistiveTertiary": "var(--color-bg-assistive-tertiary)",
    "bgBrand": "var(--color-bg-brand)",
    "bgBrandHover": "var(--color-bg-brand-hover)",
    "bgBrandPressed": "var(--color-bg-brand-pressed)",
    "bgBrandSecondary": "var(--color-bg-brand-secondary)",
    "bgBrandTertiary": "var(--color-bg-brand-tertiary)",
    "bgBrandTertiaryHover": "var(--color-bg-brand-tertiary-hover)",
    "bgBrandTertiaryPressed": "var(--color-bg-brand-tertiary-pressed)",
    "bgComponent": "var(--color-bg-component)",
    "bgComponentHover": "var(--color-bg-component-hover)",
    "bgComponentPressed": "var(--color-bg-component-pressed)",
    "bgComponentSecondary": "var(--color-bg-component-secondary)",
    "bgComponentTertiary": "var(--color-bg-component-tertiary)",
    "bgComponentTertiaryHover": "var(--color-bg-component-tertiary-hover)",
    "bgComponentTertiaryPressed": "var(--color-bg-component-tertiary-pressed)",
    "bgDanger": "var(--color-bg-danger)",
    "bgDangerHover": "var(--color-bg-danger-hover)",
    "bgDangerPressed": "var(--color-bg-danger-pressed)",
    "bgDangerSecondary": "var(--color-bg-danger-secondary)",
    "bgDangerTertiary": "var(--color-bg-danger-tertiary)",
    "bgDangerTertiaryHover": "var(--color-bg-danger-tertiary-hover)",
    "bgDangerTertiaryPressed": "var(--color-bg-danger-tertiary-pressed)",
    "bgDesign": "var(--color-bg-design)",
    "bgDesignHover": "var(--color-bg-design-hover)",
    "bgDesignPressed": "var(--color-bg-design-pressed)",
    "bgDesignSecondary": "var(--color-bg-design-secondary)",
    "bgDesignTertiary": "var(--color-bg-design-tertiary)",
    "bgDesktopBackgrounded": "var(--color-bg-desktopBackgrounded)",
    "bgDesktopBackgroundedDisabled": "var(--color-bg-desktopBackgrounded-disabled)",
    "bgDesktopBackgroundedHover": "var(--color-bg-desktopBackgrounded-hover)",
    "bgDesktopBackgroundedPressed": "var(--color-bg-desktopBackgrounded-pressed)",
    "bgDesktopBackgroundedSecondary": "var(--color-bg-desktopBackgrounded-secondary)",
    "bgDesktopBackgroundedTertiary": "var(--color-bg-desktopBackgrounded-tertiary)",
    "bgDesktopForeground": "var(--color-bg-desktopForeground)",
    "bgDesktopForegroundDisabled": "var(--color-bg-desktopForeground-disabled)",
    "bgDesktopForegroundHover": "var(--color-bg-desktopForeground-hover)",
    "bgDesktopForegroundPressed": "var(--color-bg-desktopForeground-pressed)",
    "bgDesktopForegroundSecondary": "var(--color-bg-desktopForeground-secondary)",
    "bgDesktopForegroundTertiary": "var(--color-bg-desktopForeground-tertiary)",
    "bgDesktopFullscreen": "var(--color-bg-desktopFullscreen)",
    "bgDesktopFullscreenDisabled": "var(--color-bg-desktopFullscreen-disabled)",
    "bgDesktopFullscreenHover": "var(--color-bg-desktopFullscreen-hover)",
    "bgDesktopFullscreenPressed": "var(--color-bg-desktopFullscreen-pressed)",
    "bgDesktopFullscreenSecondary": "var(--color-bg-desktopFullscreen-secondary)",
    "bgDesktopFullscreenTertiary": "var(--color-bg-desktopFullscreen-tertiary)",
    "bgDisabled": "var(--color-bg-disabled)",
    "bgDisabledSecondary": "var(--color-bg-disabled-secondary)",
    "bgElevated": "var(--color-bg-elevated)",
    "bgElevatedHover": "var(--color-bg-elevated-hover)",
    "bgFigjam": "var(--color-bg-figjam)",
    "bgFigjamHover": "var(--color-bg-figjam-hover)",
    "bgFigjamPressed": "var(--color-bg-figjam-pressed)",
    "bgFigjamSecondary": "var(--color-bg-figjam-secondary)",
    "bgFigjamTertiary": "var(--color-bg-figjam-tertiary)",
    "bgFs": "var(--color-bg-fs)",
    "bgFsAssistive": "var(--color-bg-fs-assistive)",
    "bgFsAssistiveSecondary": "var(--color-bg-fs-assistive-secondary)",
    "bgFsAssistiveTertiary": "var(--color-bg-fs-assistive-tertiary)",
    "bgFsComponent": "var(--color-bg-fs-component)",
    "bgFsComponentSecondary": "var(--color-bg-fs-component-secondary)",
    "bgFsComponentTertiary": "var(--color-bg-fs-component-tertiary)",
    "bgFsDesign": "var(--color-bg-fs-design)",
    "bgFsDesignSecondary": "var(--color-bg-fs-design-secondary)",
    "bgFsDesignTertiary": "var(--color-bg-fs-design-tertiary)",
    "bgFsMeasure": "var(--color-bg-fs-measure)",
    "bgFsMeasureHover": "var(--color-bg-fs-measure-hover)",
    "bgFsMeasureSecondary": "var(--color-bg-fs-measure-secondary)",
    "bgFsMeasureTertiary": "var(--color-bg-fs-measure-tertiary)",
    "bgFsSelected": "var(--color-bg-fs-selected)",
    "bgFsSelectedSecondary": "var(--color-bg-fs-selected-secondary)",
    "bgFsTemplate": "var(--color-bg-fs-template)",
    "bgFsTemplateSecondary": "var(--color-bg-fs-template-secondary)",
    "bgFsTemplateTertiary": "var(--color-bg-fs-template-tertiary)",
    "bgFsTertiary": "var(--color-bg-fs-tertiary)",
    "bgHandoff": "var(--color-bg-handoff)",
    "bgHandoffHover": "var(--color-bg-handoff-hover)",
    "bgHandoffPressed": "var(--color-bg-handoff-pressed)",
    "bgHandoffSecondary": "var(--color-bg-handoff-secondary)",
    "bgHandoffTertiary": "var(--color-bg-handoff-tertiary)",
    "bgHover": "var(--color-bg-hover)",
    "bgInfo": "var(--color-bg-info)",
    "bgInverse": "var(--color-bg-inverse)",
    "bgInverseHover": "var(--color-bg-inverse-hover)",
    "bgInversePressed": "var(--color-bg-inverse-pressed)",
    "bgMeasure": "var(--color-bg-measure)",
    "bgMeasureHover": "var(--color-bg-measure-hover)",
    "bgMeasurePressed": "var(--color-bg-measure-pressed)",
    "bgMeasureSecondary": "var(--color-bg-measure-secondary)",
    "bgMeasureTertiary": "var(--color-bg-measure-tertiary)",
    "bgMenu": "var(--color-bg-menu)",
    "bgMenuDisabled": "var(--color-bg-menu-disabled)",
    "bgMenuHover": "var(--color-bg-menu-hover)",
    "bgMenuPressed": "var(--color-bg-menu-pressed)",
    "bgMenuSecondary": "var(--color-bg-menu-secondary)",
    "bgMenuSelected": "var(--color-bg-menu-selected)",
    "bgMenuSelectedHover": "var(--color-bg-menu-selected-hover)",
    "bgMenuSelectedPressed": "var(--color-bg-menu-selected-pressed)",
    "bgMenuSelectedSecondary": "var(--color-bg-menu-selected-secondary)",
    "bgMenuSelectedTertiary": "var(--color-bg-menu-selected-tertiary)",
    "bgMenuTertiary": "var(--color-bg-menu-tertiary)",
    "bgOnselected": "var(--color-bg-onselected)",
    "bgOnselectedHover": "var(--color-bg-onselected-hover)",
    "bgOnselectedPressed": "var(--color-bg-onselected-pressed)",
    "bgPressed": "var(--color-bg-pressed)",
    "bgSecondary": "var(--color-bg-secondary)",
    "bgSecondaryHover": "var(--color-bg-secondary-hover)",
    "bgSecondaryPressed": "var(--color-bg-secondary-pressed)",
    "bgSelected": "var(--color-bg-selected)",
    "bgSelectedHover": "var(--color-bg-selected-hover)",
    "bgSelectedPressed": "var(--color-bg-selected-pressed)",
    "bgSelectedSecondary": "var(--color-bg-selected-secondary)",
    "bgSelectedStrong": "var(--color-bg-selected-strong)",
    "bgSelectedTertiary": "var(--color-bg-selected-tertiary)",
    "bgStrongHover": "var(--color-bg-strong-hover)",
    "bgStrongPressed": "var(--color-bg-strong-pressed)",
    "bgSuccess": "var(--color-bg-success)",
    "bgSuccessHover": "var(--color-bg-success-hover)",
    "bgSuccessPressed": "var(--color-bg-success-pressed)",
    "bgSuccessSecondary": "var(--color-bg-success-secondary)",
    "bgSuccessTertiary": "var(--color-bg-success-tertiary)",
    "bgSuccessTertiaryHover": "var(--color-bg-success-tertiary-hover)",
    "bgSuccessTertiaryPressed": "var(--color-bg-success-tertiary-pressed)",
    "bgTemplate": "var(--color-bg-template)",
    "bgTemplateSecondary": "var(--color-bg-template-secondary)",
    "bgTemplateTertiary": "var(--color-bg-template-tertiary)",
    "bgTertiary": "var(--color-bg-tertiary)",
    "bgToolbar": "var(--color-bg-toolbar)",
    "bgToolbarDisabled": "var(--color-bg-toolbar-disabled)",
    "bgToolbarHover": "var(--color-bg-toolbar-hover)",
    "bgToolbarPressed": "var(--color-bg-toolbar-pressed)",
    "bgToolbarSecondary": "var(--color-bg-toolbar-secondary)",
    "bgToolbarSelected": "var(--color-bg-toolbar-selected)",
    "bgToolbarSelectedHover": "var(--color-bg-toolbar-selected-hover)",
    "bgToolbarSelectedPressed": "var(--color-bg-toolbar-selected-pressed)",
    "bgToolbarSelectedSecondary": "var(--color-bg-toolbar-selected-secondary)",
    "bgToolbarSelectedTertiary": "var(--color-bg-toolbar-selected-tertiary)",
    "bgToolbarTertiary": "var(--color-bg-toolbar-tertiary)",
    "bgTooltip": "var(--color-bg-tooltip)",
    "bgTooltipDisabled": "var(--color-bg-tooltip-disabled)",
    "bgTooltipHover": "var(--color-bg-tooltip-hover)",
    "bgTooltipPressed": "var(--color-bg-tooltip-pressed)",
    "bgTooltipSecondary": "var(--color-bg-tooltip-secondary)",
    "bgTooltipSelected": "var(--color-bg-tooltip-selected)",
    "bgTooltipSelectedHover": "var(--color-bg-tooltip-selected-hover)",
    "bgTooltipSelectedPressed": "var(--color-bg-tooltip-selected-pressed)",
    "bgTooltipSelectedSecondary": "var(--color-bg-tooltip-selected-secondary)",
    "bgTooltipSelectedTertiary": "var(--color-bg-tooltip-selected-tertiary)",
    "bgTooltipTertiary": "var(--color-bg-tooltip-tertiary)",
    "bgTransparent": "var(--color-bg-transparent)",
    "bgTransparentHover": "var(--color-bg-transparent-hover)",
    "bgTransparentPressed": "var(--color-bg-transparent-pressed)",
    "bgTransparentSecondary": "var(--color-bg-transparent-secondary)",
    "bgWarning": "var(--color-bg-warning)",
    "bgWarningHover": "var(--color-bg-warning-hover)",
    "bgWarningPressed": "var(--color-bg-warning-pressed)",
    "bgWarningSecondary": "var(--color-bg-warning-secondary)",
    "bgWarningTertiary": "var(--color-bg-warning-tertiary)",
    "bgWarningTertiaryHover": "var(--color-bg-warning-tertiary-hover)",
    "bgWarningTertiaryPressed": "var(--color-bg-warning-tertiary-pressed)",
    "bgannotationblue": "var(--color-bgannotationblue)",
    "bgannotationgreen": "var(--color-bgannotationgreen)",
    "bgannotationorange": "var(--color-bgannotationorange)",
    "bgannotationpink": "var(--color-bgannotationpink)",
    "bgannotationpurple": "var(--color-bgannotationpurple)",
    "bgannotationred": "var(--color-bgannotationred)",
    "bgannotationteal": "var(--color-bgannotationteal)",
    "bgannotationyellow": "var(--color-bgannotationyellow)",
    "bghoverondarkcanvas": "var(--color-bghoverondarkcanvas)",
    "bghoveronlightcanvas": "var(--color-bghoveronlightcanvas)",
    "bghovertransparent": "var(--color-bghovertransparent)",
    "bginspectpadding": "var(--color-bginspectpadding)",
    "bginspectpaddingtertiary": "var(--color-bginspectpaddingtertiary)",
    "bginspectspacing": "var(--color-bginspectspacing)",
    "bgsecondaryoncanvas": "var(--color-bgsecondaryoncanvas)",
    "bgselectedarea": "var(--color-bgselectedarea)",
    "bgswitchoff": "var(--color-bgswitchoff)",
    "bgtoolbarmodeswitcher": "var(--color-bgtoolbarmodeswitcher)",
    "bgtoolbarmodeswitcherHover": "var(--color-bgtoolbarmodeswitcher-hover)",
    "bgtransparent": "var(--color-bgtransparent)",
    "bgtransparentSecondaryHover": "var(--color-bgtransparent-secondary-hover)",
    "bgtransparentSecondaryPressed": "var(--color-bgtransparent-secondary-pressed)",
    "bgtransparentsecondary": "var(--color-bgtransparentsecondary)",
    "bgvoting": "var(--color-bgvoting)",
    "bgvotingsecondary": "var(--color-bgvotingsecondary)",
    "bgvotingtertiary": "var(--color-bgvotingtertiary)",
    "bgvotingwheeldial": "var(--color-bgvotingwheeldial)",
    "bgvotingwheelhover": "var(--color-bgvotingwheelhover)",
    "border": "var(--color-border)",
    "borderAssistive": "var(--color-border-assistive)",
    "borderAssistiveStrong": "var(--color-border-assistive-strong)",
    "borderBrand": "var(--color-border-brand)",
    "borderBrandStrong": "var(--color-border-brand-strong)",
    "borderComponent": "var(--color-border-component)",
    "borderComponentHover": "var(--color-border-component-hover)",
    "borderComponentSelected": "var(--color-border-component-selected)",
    "borderComponentStrong": "var(--color-border-component-strong)",
    "borderDanger": "var(--color-border-danger)",
    "borderDangerStrong": "var(--color-border-danger-strong)",
    "borderDesign": "var(--color-border-design)",
    "borderDesignStrong": "var(--color-border-design-strong)",
    "borderDesktopBackgrounded": "var(--color-border-desktopBackgrounded)",
    "borderDesktopBackgroundedDisabled": "var(--color-border-desktopBackgrounded-disabled)",
    "borderDesktopBackgroundedStrong": "var(--color-border-desktopBackgrounded-strong)",
    "borderDesktopForeground": "var(--color-border-desktopForeground)",
    "borderDesktopForegroundDisabled": "var(--color-border-desktopForeground-disabled)",
    "borderDesktopForegroundStrong": "var(--color-border-desktopForeground-strong)",
    "borderDesktopFullscreen": "var(--color-border-desktopFullscreen)",
    "borderDesktopFullscreenDisabled": "var(--color-border-desktopFullscreen-disabled)",
    "borderDesktopFullscreenStrong": "var(--color-border-desktopFullscreen-strong)",
    "borderDisabled": "var(--color-border-disabled)",
    "borderDisabledStrong": "var(--color-border-disabled-strong)",
    "borderFigjam": "var(--color-border-figjam)",
    "borderFigjamStrong": "var(--color-border-figjam-strong)",
    "borderFs": "var(--color-border-fs)",
    "borderFsAssistive": "var(--color-border-fs-assistive)",
    "borderFsAssistiveStrong": "var(--color-border-fs-assistive-strong)",
    "borderFsComponent": "var(--color-border-fs-component)",
    "borderFsComponentStrong": "var(--color-border-fs-component-strong)",
    "borderFsDesign": "var(--color-border-fs-design)",
    "borderFsDesignStrong": "var(--color-border-fs-design-strong)",
    "borderFsMeasure": "var(--color-border-fs-measure)",
    "borderFsMeasureStrong": "var(--color-border-fs-measure-strong)",
    "borderFsOnassistive": "var(--color-border-fs-onassistive)",
    "borderFsOnassistiveStrong": "var(--color-border-fs-onassistive-strong)",
    "borderFsOncomponent": "var(--color-border-fs-oncomponent)",
    "borderFsOncomponentStrong": "var(--color-border-fs-oncomponent-strong)",
    "borderFsOndesign": "var(--color-border-fs-ondesign)",
    "borderFsOndesignStrong": "var(--color-border-fs-ondesign-strong)",
    "borderFsOnmeasure": "var(--color-border-fs-onmeasure)",
    "borderFsOnmeasureStrong": "var(--color-border-fs-onmeasure-strong)",
    "borderFsOnselected": "var(--color-border-fs-onselected)",
    "borderFsOnselectedStrong": "var(--color-border-fs-onselected-strong)",
    "borderFsOntemplate": "var(--color-border-fs-ontemplate)",
    "borderFsOntemplateStrong": "var(--color-border-fs-ontemplate-strong)",
    "borderFsSelected": "var(--color-border-fs-selected)",
    "borderFsSelectedStrong": "var(--color-border-fs-selected-strong)",
    "borderFsStrong": "var(--color-border-fs-strong)",
    "borderFsTemplate": "var(--color-border-fs-template)",
    "borderFsTemplateStrong": "var(--color-border-fs-template-strong)",
    "borderHandoff": "var(--color-border-handoff)",
    "borderHandoffStrong": "var(--color-border-handoff-strong)",
    "borderMeasure": "var(--color-border-measure)",
    "borderMeasureStrong": "var(--color-border-measure-strong)",
    "borderMenu": "var(--color-border-menu)",
    "borderMenuDisabled": "var(--color-border-menu-disabled)",
    "borderMenuDisabledStrong": "var(--color-border-menu-disabled-strong)",
    "borderMenuOnselected": "var(--color-border-menu-onselected)",
    "borderMenuOnselectedStrong": "var(--color-border-menu-onselected-strong)",
    "borderMenuSelected": "var(--color-border-menu-selected)",
    "borderMenuSelectedStrong": "var(--color-border-menu-selected-strong)",
    "borderMenuStrong": "var(--color-border-menu-strong)",
    "borderOnassistive": "var(--color-border-onassistive)",
    "borderOnassistiveStrong": "var(--color-border-onassistive-strong)",
    "borderOnbrand": "var(--color-border-onbrand)",
    "borderOnbrandStrong": "var(--color-border-onbrand-strong)",
    "borderOncomponent": "var(--color-border-oncomponent)",
    "borderOncomponentStrong": "var(--color-border-oncomponent-strong)",
    "borderOndanger": "var(--color-border-ondanger)",
    "borderOndangerStrong": "var(--color-border-ondanger-strong)",
    "borderOndesign": "var(--color-border-ondesign)",
    "borderOndesignStrong": "var(--color-border-ondesign-strong)",
    "borderOnfigjam": "var(--color-border-onfigjam)",
    "borderOnfigjamStrong": "var(--color-border-onfigjam-strong)",
    "borderOnmeasure": "var(--color-border-onmeasure)",
    "borderOnmeasureStrong": "var(--color-border-onmeasure-strong)",
    "borderOnselected": "var(--color-border-onselected)",
    "borderOnselectedStrong": "var(--color-border-onselected-strong)",
    "borderOnsuccess": "var(--color-border-onsuccess)",
    "borderOnsuccessStrong": "var(--color-border-onsuccess-strong)",
    "borderOntemplate": "var(--color-border-ontemplate)",
    "borderOntemplateStrong": "var(--color-border-ontemplate-strong)",
    "borderOnwarning": "var(--color-border-onwarning)",
    "borderOnwarningStrong": "var(--color-border-onwarning-strong)",
    "borderSelected": "var(--color-border-selected)",
    "borderSelectedStrong": "var(--color-border-selected-strong)",
    "borderStrong": "var(--color-border-strong)",
    "borderSuccess": "var(--color-border-success)",
    "borderSuccessStrong": "var(--color-border-success-strong)",
    "borderTemplateStrong": "var(--color-border-template-strong)",
    "borderToolbar": "var(--color-border-toolbar)",
    "borderToolbarDisabled": "var(--color-border-toolbar-disabled)",
    "borderToolbarOnselected": "var(--color-border-toolbar-onselected)",
    "borderToolbarSelected": "var(--color-border-toolbar-selected)",
    "borderToolbarSelectedStrong": "var(--color-border-toolbar-selected-strong)",
    "borderToolbarStrong": "var(--color-border-toolbar-strong)",
    "borderTooltip": "var(--color-border-tooltip)",
    "borderTooltipDisabled": "var(--color-border-tooltip-disabled)",
    "borderTooltipDisabledStrong": "var(--color-border-tooltip-disabled-strong)",
    "borderTooltipOnselected": "var(--color-border-tooltip-onselected)",
    "borderTooltipOnselectedStrong": "var(--color-border-tooltip-onselected-strong)",
    "borderTooltipSelected": "var(--color-border-tooltip-selected)",
    "borderTooltipSelectedStrong": "var(--color-border-tooltip-selected-strong)",
    "borderTooltipStrong": "var(--color-border-tooltip-strong)",
    "borderWarning": "var(--color-border-warning)",
    "borderWarningStrong": "var(--color-border-warning-strong)",
    "borderinspectpadding": "var(--color-borderinspectpadding)",
    "borderinspectspacing": "var(--color-borderinspectspacing)",
    "borderplacecrosshair": "var(--color-borderplacecrosshair)",
    "borderselectedec": "var(--color-borderselectedec)",
    "bordertranslucent": "var(--color-bordertranslucent)",
    "bordertranslucentstrong": "var(--color-bordertranslucentstrong)",
    "code": "var(--color-code)",
    "codeaccent": "var(--color-codeaccent)",
    "codeattribute": "var(--color-codeattribute)",
    "codeclassname": "var(--color-codeclassname)",
    "codecomment": "var(--color-codecomment)",
    "codeproperty": "var(--color-codeproperty)",
    "codestring": "var(--color-codestring)",
    "codestylename": "var(--color-codestylename)",
    "codetag": "var(--color-codetag)",
    "codevalue": "var(--color-codevalue)",
    "codevariable": "var(--color-codevariable)",
    "conditionalborder": "var(--color-conditionalborder)",
    "controliconoutline": "var(--color-controliconoutline)",
    "controlknoboffoutline": "var(--color-controlknoboffoutline)",
    "fillplacecrosshair": "var(--color-fillplacecrosshair)",
    "fsAutoFillHighlight": "var(--color-fsAutoFillHighlight)",
    "fsBgHeaderOnDarkCanvas": "var(--color-fsBgHeaderOnDarkCanvas)",
    "fsBgHeaderOnLightCanvas": "var(--color-fsBgHeaderOnLightCanvas)",
    "fsBgInputOnLightCanvas": "var(--color-fsBgInputOnLightCanvas)",
    "fsBorderDesignShadowStrong": "var(--color-fsBorderDesignShadowStrong)",
    "fsBorderHeaderOnDarkCanvas": "var(--color-fsBorderHeaderOnDarkCanvas)",
    "fsBorderHeaderOnLightCanvas": "var(--color-fsBorderHeaderOnLightCanvas)",
    "fsBorderPlaceholder": "var(--color-fsBorderPlaceholder)",
    "fsBorderSelectedImmutableNode": "var(--color-fsBorderSelectedImmutableNode)",
    "fsBorderSelectedImmutableNodeSecondary": "var(--color-fsBorderSelectedImmutableNodeSecondary)",
    "fsCanvasDefaultFill": "var(--color-fsCanvasDefaultFill)",
    "fsCodeNodeBorder": "var(--color-fsCodeNodeBorder)",
    "fsCodeNodeBorderSecondary": "var(--color-fsCodeNodeBorderSecondary)",
    "fsCodeNodeTextErrorOnDarkCanvas": "var(--color-fsCodeNodeTextErrorOnDarkCanvas)",
    "fsCodeNodeTextErrorOnLightCanvas": "var(--color-fsCodeNodeTextErrorOnLightCanvas)",
    "fsCodeNodeTextOnDarkCanvas": "var(--color-fsCodeNodeTextOnDarkCanvas)",
    "fsCodeNodeTextOnLightCanvas": "var(--color-fsCodeNodeTextOnLightCanvas)",
    "fsDevHandoffAutolayoutPadding": "var(--color-fsDevHandoffAutolayoutPadding)",
    "fsDevHandoffAutolayoutSpacing": "var(--color-fsDevHandoffAutolayoutSpacing)",
    "fsFrameDefaultFill": "var(--color-fsFrameDefaultFill)",
    "fsGridCellOutline": "var(--color-fsGridCellOutline)",
    "fsGridCellSelection": "var(--color-fsGridCellSelection)",
    "fsGridComponentCellOutline": "var(--color-fsGridComponentCellOutline)",
    "fsGridComponentCellSelection": "var(--color-fsGridComponentCellSelection)",
    "fsIconOnDarkCanvas": "var(--color-fsIconOnDarkCanvas)",
    "fsIconOnDarkCanvasSecondary": "var(--color-fsIconOnDarkCanvasSecondary)",
    "fsIconOnLightCanvas": "var(--color-fsIconOnLightCanvas)",
    "fsIconOnLightCanvasSecondary": "var(--color-fsIconOnLightCanvasSecondary)",
    "fsNodeHandle": "var(--color-fsNodeHandle)",
    "fsNodeLabelNoBG": "var(--color-fsNodeLabelNoBG)",
    "fsNodeSymbolSelectedSecondary": "var(--color-fsNodeSymbolSelectedSecondary)",
    "fsNoodleCenterLine": "var(--color-fsNoodleCenterLine)",
    "fsShapeDefaultFill": "var(--color-fsShapeDefaultFill)",
    "fsSitesResponsiveSetTextOnDarkCanvas": "var(--color-fsSitesResponsiveSetTextOnDarkCanvas)",
    "fsSitesResponsiveSetTextOnLightCanvas": "var(--color-fsSitesResponsiveSetTextOnLightCanvas)",
    "fsSnappingOverlay": "var(--color-fsSnappingOverlay)",
    "fsStickyAuthorTextOnDark": "var(--color-fsStickyAuthorTextOnDark)",
    "fsStickyAuthorTextOnLight": "var(--color-fsStickyAuthorTextOnLight)",
    "fsTextComponentOnDarkCanvas": "var(--color-fsTextComponentOnDarkCanvas)",
    "fsTextComponentOnLightCanvas": "var(--color-fsTextComponentOnLightCanvas)",
    "fsTextOnDarkCanvas": "var(--color-fsTextOnDarkCanvas)",
    "fsTextOnDarkCanvasSecondary": "var(--color-fsTextOnDarkCanvasSecondary)",
    "fsTextOnLightCanvas": "var(--color-fsTextOnLightCanvas)",
    "fsTextOnLightCanvasSecondary": "var(--color-fsTextOnLightCanvasSecondary)",
    "fsTextSelectedOnDarkCanvas": "var(--color-fsTextSelectedOnDarkCanvas)",
    "fsTextSelectedOnLightCanvas": "var(--color-fsTextSelectedOnLightCanvas)",
    "fsVectorInactive": "var(--color-fsVectorInactive)",
    "fsWidgetFrameTextOnDarkCanvas": "var(--color-fsWidgetFrameTextOnDarkCanvas)",
    "fsWidgetFrameTextOnLightCanvas": "var(--color-fsWidgetFrameTextOnLightCanvas)",
    "fsWidgetFrameTextSelectedOnDarkCanvas": "var(--color-fsWidgetFrameTextSelectedOnDarkCanvas)",
    "fsWidgetFrameTextSelectedOnLightCanvas": "var(--color-fsWidgetFrameTextSelectedOnLightCanvas)",
    "gauge": "var(--color-gauge)",
    "gaugeBrand": "var(--color-gauge-brand)",
    "gaugeBrandSecondary": "var(--color-gauge-brand-secondary)",
    "gaugeDanger": "var(--color-gauge-danger)",
    "gaugeDangerSecondary": "var(--color-gauge-danger-secondary)",
    "gaugeSecondary": "var(--color-gauge-secondary)",
    "gaugeStrong": "var(--color-gauge-strong)",
    "gaugeSuccess": "var(--color-gauge-success)",
    "gaugeSuccessSecondary": "var(--color-gauge-success-secondary)",
    "gaugeWarning": "var(--color-gauge-warning)",
    "gaugeWarningSecondary": "var(--color-gauge-warning-secondary)",
    "icon": "var(--color-icon)",
    "iconAssistive": "var(--color-icon-assistive)",
    "iconAssistivePressed": "var(--color-icon-assistive-pressed)",
    "iconAssistiveSecondary": "var(--color-icon-assistive-secondary)",
    "iconAssistiveTertiary": "var(--color-icon-assistive-tertiary)",
    "iconBrand": "var(--color-icon-brand)",
    "iconBrandPressed": "var(--color-icon-brand-pressed)",
    "iconBrandSecondary": "var(--color-icon-brand-secondary)",
    "iconBrandTertiary": "var(--color-icon-brand-tertiary)",
    "iconComponent": "var(--color-icon-component)",
    "iconComponentPressed": "var(--color-icon-component-pressed)",
    "iconComponentSecondary": "var(--color-icon-component-secondary)",
    "iconComponentTertiary": "var(--color-icon-component-tertiary)",
    "iconDanger": "var(--color-icon-danger)",
    "iconDangerHover": "var(--color-icon-danger-hover)",
    "iconDangerPressed": "var(--color-icon-danger-pressed)",
    "iconDangerSecondary": "var(--color-icon-danger-secondary)",
    "iconDangerSecondaryHover": "var(--color-icon-danger-secondary-hover)",
    "iconDangerTertiary": "var(--color-icon-danger-tertiary)",
    "iconDesign": "var(--color-icon-design)",
    "iconDesignPressed": "var(--color-icon-design-pressed)",
    "iconDesignSecondary": "var(--color-icon-design-secondary)",
    "iconDesignTertiary": "var(--color-icon-design-tertiary)",
    "iconDesktopBackgrounded": "var(--color-icon-desktopBackgrounded)",
    "iconDesktopBackgroundedDanger": "var(--color-icon-desktopBackgrounded-danger)",
    "iconDesktopBackgroundedDisabled": "var(--color-icon-desktopBackgrounded-disabled)",
    "iconDesktopBackgroundedHover": "var(--color-icon-desktopBackgrounded-hover)",
    "iconDesktopBackgroundedOndisabled": "var(--color-icon-desktopBackgrounded-ondisabled)",
    "iconDesktopBackgroundedSecondary": "var(--color-icon-desktopBackgrounded-secondary)",
    "iconDesktopBackgroundedSecondaryHover": "var(--color-icon-desktopBackgrounded-secondary-hover)",
    "iconDesktopBackgroundedTertiary": "var(--color-icon-desktopBackgrounded-tertiary)",
    "iconDesktopBackgroundedTertiaryHover": "var(--color-icon-desktopBackgrounded-tertiary-hover)",
    "iconDesktopBackgroundedWarning": "var(--color-icon-desktopBackgrounded-warning)",
    "iconDesktopForeground": "var(--color-icon-desktopForeground)",
    "iconDesktopForegroundDanger": "var(--color-icon-desktopForeground-danger)",
    "iconDesktopForegroundDisabled": "var(--color-icon-desktopForeground-disabled)",
    "iconDesktopForegroundHover": "var(--color-icon-desktopForeground-hover)",
    "iconDesktopForegroundOndisabled": "var(--color-icon-desktopForeground-ondisabled)",
    "iconDesktopForegroundSecondary": "var(--color-icon-desktopForeground-secondary)",
    "iconDesktopForegroundSecondaryHover": "var(--color-icon-desktopForeground-secondary-hover)",
    "iconDesktopForegroundTertiary": "var(--color-icon-desktopForeground-tertiary)",
    "iconDesktopForegroundTertiaryHover": "var(--color-icon-desktopForeground-tertiary-hover)",
    "iconDesktopForegroundWarning": "var(--color-icon-desktopForeground-warning)",
    "iconDesktopFullscreen": "var(--color-icon-desktopFullscreen)",
    "iconDesktopFullscreenDanger": "var(--color-icon-desktopFullscreen-danger)",
    "iconDesktopFullscreenDisabled": "var(--color-icon-desktopFullscreen-disabled)",
    "iconDesktopFullscreenHover": "var(--color-icon-desktopFullscreen-hover)",
    "iconDesktopFullscreenOndisabled": "var(--color-icon-desktopFullscreen-ondisabled)",
    "iconDesktopFullscreenSecondary": "var(--color-icon-desktopFullscreen-secondary)",
    "iconDesktopFullscreenSecondaryHover": "var(--color-icon-desktopFullscreen-secondary-hover)",
    "iconDesktopFullscreenTertiary": "var(--color-icon-desktopFullscreen-tertiary)",
    "iconDesktopFullscreenTertiaryHover": "var(--color-icon-desktopFullscreen-tertiary-hover)",
    "iconDesktopFullscreenWarning": "var(--color-icon-desktopFullscreen-warning)",
    "iconDisabled": "var(--color-icon-disabled)",
    "iconFigjam": "var(--color-icon-figjam)",
    "iconFigjamPressed": "var(--color-icon-figjam-pressed)",
    "iconFigjamSecondary": "var(--color-icon-figjam-secondary)",
    "iconFigjamTertiary": "var(--color-icon-figjam-tertiary)",
    "iconFs": "var(--color-icon-fs)",
    "iconFsAssistive": "var(--color-icon-fs-assistive)",
    "iconFsComponent": "var(--color-icon-fs-component)",
    "iconFsDesign": "var(--color-icon-fs-design)",
    "iconFsMeasure": "var(--color-icon-fs-measure)",
    "iconFsOnassistive": "var(--color-icon-fs-onassistive)",
    "iconFsOncomponent": "var(--color-icon-fs-oncomponent)",
    "iconFsOndesign": "var(--color-icon-fs-ondesign)",
    "iconFsOnmeasure": "var(--color-icon-fs-onmeasure)",
    "iconFsOnselected": "var(--color-icon-fs-onselected)",
    "iconFsOntemplate": "var(--color-icon-fs-ontemplate)",
    "iconFsSecondary": "var(--color-icon-fs-secondary)",
    "iconFsSelected": "var(--color-icon-fs-selected)",
    "iconFsTemplate": "var(--color-icon-fs-template)",
    "iconFsTertiary": "var(--color-icon-fs-tertiary)",
    "iconHandoff": "var(--color-icon-handoff)",
    "iconHandoffPressed": "var(--color-icon-handoff-pressed)",
    "iconHandoffSecondary": "var(--color-icon-handoff-secondary)",
    "iconHandoffTertiary": "var(--color-icon-handoff-tertiary)",
    "iconHover": "var(--color-icon-hover)",
    "iconMeasure": "var(--color-icon-measure)",
    "iconMeasureHover": "var(--color-icon-measure-hover)",
    "iconMeasurePressed": "var(--color-icon-measure-pressed)",
    "iconMeasureSecondary": "var(--color-icon-measure-secondary)",
    "iconMeasureSecondaryHover": "var(--color-icon-measure-secondary-hover)",
    "iconMeasureTertiary": "var(--color-icon-measure-tertiary)",
    "iconMenu": "var(--color-icon-menu)",
    "iconMenuDanger": "var(--color-icon-menu-danger)",
    "iconMenuDisabled": "var(--color-icon-menu-disabled)",
    "iconMenuHover": "var(--color-icon-menu-hover)",
    "iconMenuOndisabled": "var(--color-icon-menu-ondisabled)",
    "iconMenuOnselected": "var(--color-icon-menu-onselected)",
    "iconMenuPressed": "var(--color-icon-menu-pressed)",
    "iconMenuSecondary": "var(--color-icon-menu-secondary)",
    "iconMenuSecondaryHover": "var(--color-icon-menu-secondary-hover)",
    "iconMenuSelected": "var(--color-icon-menu-selected)",
    "iconMenuSelectedSecondary": "var(--color-icon-menu-selected-secondary)",
    "iconMenuSelectedTertiary": "var(--color-icon-menu-selected-tertiary)",
    "iconMenuTertiary": "var(--color-icon-menu-tertiary)",
    "iconMenuTertiaryHover": "var(--color-icon-menu-tertiary-hover)",
    "iconMenuWarning": "var(--color-icon-menu-warning)",
    "iconOnassistive": "var(--color-icon-onassistive)",
    "iconOnassistiveSecondary": "var(--color-icon-onassistive-secondary)",
    "iconOnassistiveTertiary": "var(--color-icon-onassistive-tertiary)",
    "iconOnbrand": "var(--color-icon-onbrand)",
    "iconOnbrandSecondary": "var(--color-icon-onbrand-secondary)",
    "iconOnbrandTertiary": "var(--color-icon-onbrand-tertiary)",
    "iconOncomponent": "var(--color-icon-oncomponent)",
    "iconOncomponentSecondary": "var(--color-icon-oncomponent-secondary)",
    "iconOncomponentTertiary": "var(--color-icon-oncomponent-tertiary)",
    "iconOndanger": "var(--color-icon-ondanger)",
    "iconOndangerSecondary": "var(--color-icon-ondanger-secondary)",
    "iconOndangerTertiary": "var(--color-icon-ondanger-tertiary)",
    "iconOndesign": "var(--color-icon-ondesign)",
    "iconOndesignSecondary": "var(--color-icon-ondesign-secondary)",
    "iconOndesignTertiary": "var(--color-icon-ondesign-tertiary)",
    "iconOndisabled": "var(--color-icon-ondisabled)",
    "iconOnfigjam": "var(--color-icon-onfigjam)",
    "iconOnfigjamSecondary": "var(--color-icon-onfigjam-secondary)",
    "iconOnfigjamTertiary": "var(--color-icon-onfigjam-tertiary)",
    "iconOninverse": "var(--color-icon-oninverse)",
    "iconOnmeasure": "var(--color-icon-onmeasure)",
    "iconOnmeasureSecondary": "var(--color-icon-onmeasure-secondary)",
    "iconOnmeasureTertiary": "var(--color-icon-onmeasure-tertiary)",
    "iconOnselected": "var(--color-icon-onselected)",
    "iconOnselectedSecondary": "var(--color-icon-onselected-secondary)",
    "iconOnselectedStrong": "var(--color-icon-onselected-strong)",
    "iconOnselectedTertiary": "var(--color-icon-onselected-tertiary)",
    "iconOnsuccess": "var(--color-icon-onsuccess)",
    "iconOnsuccessSecondary": "var(--color-icon-onsuccess-secondary)",
    "iconOnsuccessTertiary": "var(--color-icon-onsuccess-tertiary)",
    "iconOntemplate": "var(--color-icon-ontemplate)",
    "iconOnwarning": "var(--color-icon-onwarning)",
    "iconOnwarningSecondary": "var(--color-icon-onwarning-secondary)",
    "iconOnwarningTertiary": "var(--color-icon-onwarning-tertiary)",
    "iconPressed": "var(--color-icon-pressed)",
    "iconSecondary": "var(--color-icon-secondary)",
    "iconSecondaryHover": "var(--color-icon-secondary-hover)",
    "iconSelected": "var(--color-icon-selected)",
    "iconSelectedSecondary": "var(--color-icon-selected-secondary)",
    "iconSelectedTertiary": "var(--color-icon-selected-tertiary)",
    "iconSuccess": "var(--color-icon-success)",
    "iconSuccessPressed": "var(--color-icon-success-pressed)",
    "iconSuccessSecondary": "var(--color-icon-success-secondary)",
    "iconSuccessTertiary": "var(--color-icon-success-tertiary)",
    "iconTemplate": "var(--color-icon-template)",
    "iconTemplateSecondary": "var(--color-icon-template-secondary)",
    "iconTertiary": "var(--color-icon-tertiary)",
    "iconTertiaryHover": "var(--color-icon-tertiary-hover)",
    "iconToolbar": "var(--color-icon-toolbar)",
    "iconToolbarDanger": "var(--color-icon-toolbar-danger)",
    "iconToolbarDisabled": "var(--color-icon-toolbar-disabled)",
    "iconToolbarHover": "var(--color-icon-toolbar-hover)",
    "iconToolbarOndisabled": "var(--color-icon-toolbar-ondisabled)",
    "iconToolbarOnselected": "var(--color-icon-toolbar-onselected)",
    "iconToolbarPressed": "var(--color-icon-toolbar-pressed)",
    "iconToolbarSecondary": "var(--color-icon-toolbar-secondary)",
    "iconToolbarSecondaryHover": "var(--color-icon-toolbar-secondary-hover)",
    "iconToolbarSelected": "var(--color-icon-toolbar-selected)",
    "iconToolbarSelectedSecondary": "var(--color-icon-toolbar-selected-secondary)",
    "iconToolbarSelectedTertiary": "var(--color-icon-toolbar-selected-tertiary)",
    "iconToolbarTertiary": "var(--color-icon-toolbar-tertiary)",
    "iconToolbarTertiaryHover": "var(--color-icon-toolbar-tertiary-hover)",
    "iconToolbarWarning": "var(--color-icon-toolbar-warning)",
    "iconTooltip": "var(--color-icon-tooltip)",
    "iconTooltipDanger": "var(--color-icon-tooltip-danger)",
    "iconTooltipDisabled": "var(--color-icon-tooltip-disabled)",
    "iconTooltipHover": "var(--color-icon-tooltip-hover)",
    "iconTooltipOndisabled": "var(--color-icon-tooltip-ondisabled)",
    "iconTooltipOnselected": "var(--color-icon-tooltip-onselected)",
    "iconTooltipPressed": "var(--color-icon-tooltip-pressed)",
    "iconTooltipSecondary": "var(--color-icon-tooltip-secondary)",
    "iconTooltipSecondaryHover": "var(--color-icon-tooltip-secondary-hover)",
    "iconTooltipSelected": "var(--color-icon-tooltip-selected)",
    "iconTooltipSelectedSecondary": "var(--color-icon-tooltip-selected-secondary)",
    "iconTooltipSelectedTertiary": "var(--color-icon-tooltip-selected-tertiary)",
    "iconTooltipTertiary": "var(--color-icon-tooltip-tertiary)",
    "iconTooltipTertiaryHover": "var(--color-icon-tooltip-tertiary-hover)",
    "iconTooltipWarning": "var(--color-icon-tooltip-warning)",
    "iconWarning": "var(--color-icon-warning)",
    "iconWarningPressed": "var(--color-icon-warning-pressed)",
    "iconWarningSecondary": "var(--color-icon-warning-secondary)",
    "iconWarningTertiary": "var(--color-icon-warning-tertiary)",
    "icondesignfilesecondary": "var(--color-icondesignfilesecondary)",
    "iconfavorite": "var(--color-iconfavorite)",
    "iconfigjamfilesecondary": "var(--color-iconfigjamfilesecondary)",
    "iconondarkcanvas": "var(--color-iconondarkcanvas)",
    "icononlightcanvas": "var(--color-icononlightcanvas)",
    "icononvoting": "var(--color-icononvoting)",
    "iconprototypefile": "var(--color-iconprototypefile)",
    "iconprototypefilesecondary": "var(--color-iconprototypefilesecondary)",
    "iconpublishedfile": "var(--color-iconpublishedfile)",
    "iconpublishedfilesecondary": "var(--color-iconpublishedfilesecondary)",
    "loading": "var(--color-loading)",
    "loadingmenu": "var(--color-loadingmenu)",
    "loadingsecondary": "var(--color-loadingsecondary)",
    "loadingsecondarymenu": "var(--color-loadingsecondarymenu)",
    "modalbackdrop": "var(--color-modalbackdrop)",
    "multiplayerblue": "var(--color-multiplayerblue)",
    "multiplayerbluehover": "var(--color-multiplayerbluehover)",
    "multiplayerbluesecondary": "var(--color-multiplayerbluesecondary)",
    "multiplayergreen": "var(--color-multiplayergreen)",
    "multiplayergreenhover": "var(--color-multiplayergreenhover)",
    "multiplayergreensecondary": "var(--color-multiplayergreensecondary)",
    "multiplayergrey": "var(--color-multiplayergrey)",
    "multiplayergreyhover": "var(--color-multiplayergreyhover)",
    "multiplayergreysecondary": "var(--color-multiplayergreysecondary)",
    "multiplayerpink": "var(--color-multiplayerpink)",
    "multiplayerpinkhover": "var(--color-multiplayerpinkhover)",
    "multiplayerpinksecondary": "var(--color-multiplayerpinksecondary)",
    "multiplayerpurple": "var(--color-multiplayerpurple)",
    "multiplayerpurplehover": "var(--color-multiplayerpurplehover)",
    "multiplayerpurplesecondary": "var(--color-multiplayerpurplesecondary)",
    "multiplayerred": "var(--color-multiplayerred)",
    "multiplayerredhover": "var(--color-multiplayerredhover)",
    "multiplayerredsecondary": "var(--color-multiplayerredsecondary)",
    "multiplayeryellow": "var(--color-multiplayeryellow)",
    "multiplayeryellowhover": "var(--color-multiplayeryellowhover)",
    "multiplayeryellowsecondary": "var(--color-multiplayeryellowsecondary)",
    "nodehandle": "var(--color-nodehandle)",
    "prototypeloadingbackdrop": "var(--color-prototypeloadingbackdrop)",
    "scrollbar": "var(--color-scrollbar)",
    "shadow": "var(--color-shadow)",
    "tablenodehoveredprimary": "var(--color-tablenodehoveredprimary)",
    "tablenodehoveredsecondary": "var(--color-tablenodehoveredsecondary)",
    "tablenodeselected": "var(--color-tablenodeselected)",
    "templateSlot": "var(--color-template-slot)",
    "text": "var(--color-text)",
    "textAssistive": "var(--color-text-assistive)",
    "textAssistivePressed": "var(--color-text-assistive-pressed)",
    "textAssistiveSecondary": "var(--color-text-assistive-secondary)",
    "textAssistiveTertiary": "var(--color-text-assistive-tertiary)",
    "textBrand": "var(--color-text-brand)",
    "textBrandSecondary": "var(--color-text-brand-secondary)",
    "textBrandTertiary": "var(--color-text-brand-tertiary)",
    "textComponent": "var(--color-text-component)",
    "textComponentPressed": "var(--color-text-component-pressed)",
    "textComponentSecondary": "var(--color-text-component-secondary)",
    "textComponentTertiary": "var(--color-text-component-tertiary)",
    "textDanger": "var(--color-text-danger)",
    "textDangerSecondary": "var(--color-text-danger-secondary)",
    "textDangerTertiary": "var(--color-text-danger-tertiary)",
    "textDesign": "var(--color-text-design)",
    "textDesignPressed": "var(--color-text-design-pressed)",
    "textDesignSecondary": "var(--color-text-design-secondary)",
    "textDesignTertiary": "var(--color-text-design-tertiary)",
    "textDesktopBackgrounded": "var(--color-text-desktopBackgrounded)",
    "textDesktopBackgroundedDanger": "var(--color-text-desktopBackgrounded-danger)",
    "textDesktopBackgroundedDisabled": "var(--color-text-desktopBackgrounded-disabled)",
    "textDesktopBackgroundedHover": "var(--color-text-desktopBackgrounded-hover)",
    "textDesktopBackgroundedOndisabled": "var(--color-text-desktopBackgrounded-ondisabled)",
    "textDesktopBackgroundedSecondary": "var(--color-text-desktopBackgrounded-secondary)",
    "textDesktopBackgroundedSecondaryHover": "var(--color-text-desktopBackgrounded-secondary-hover)",
    "textDesktopBackgroundedTertiary": "var(--color-text-desktopBackgrounded-tertiary)",
    "textDesktopBackgroundedTertiaryHover": "var(--color-text-desktopBackgrounded-tertiary-hover)",
    "textDesktopBackgroundedWarning": "var(--color-text-desktopBackgrounded-warning)",
    "textDesktopForeground": "var(--color-text-desktopForeground)",
    "textDesktopForegroundDanger": "var(--color-text-desktopForeground-danger)",
    "textDesktopForegroundDisabled": "var(--color-text-desktopForeground-disabled)",
    "textDesktopForegroundHover": "var(--color-text-desktopForeground-hover)",
    "textDesktopForegroundOndisabled": "var(--color-text-desktopForeground-ondisabled)",
    "textDesktopForegroundSecondary": "var(--color-text-desktopForeground-secondary)",
    "textDesktopForegroundSecondaryHover": "var(--color-text-desktopForeground-secondary-hover)",
    "textDesktopForegroundTertiary": "var(--color-text-desktopForeground-tertiary)",
    "textDesktopForegroundTertiaryHover": "var(--color-text-desktopForeground-tertiary-hover)",
    "textDesktopForegroundWarning": "var(--color-text-desktopForeground-warning)",
    "textDesktopFullscreen": "var(--color-text-desktopFullscreen)",
    "textDesktopFullscreenDanger": "var(--color-text-desktopFullscreen-danger)",
    "textDesktopFullscreenDisabled": "var(--color-text-desktopFullscreen-disabled)",
    "textDesktopFullscreenHover": "var(--color-text-desktopFullscreen-hover)",
    "textDesktopFullscreenOndisabled": "var(--color-text-desktopFullscreen-ondisabled)",
    "textDesktopFullscreenSecondary": "var(--color-text-desktopFullscreen-secondary)",
    "textDesktopFullscreenSecondaryHover": "var(--color-text-desktopFullscreen-secondary-hover)",
    "textDesktopFullscreenTertiary": "var(--color-text-desktopFullscreen-tertiary)",
    "textDesktopFullscreenTertiaryHover": "var(--color-text-desktopFullscreen-tertiary-hover)",
    "textDesktopFullscreenWarning": "var(--color-text-desktopFullscreen-warning)",
    "textDisabled": "var(--color-text-disabled)",
    "textFigjam": "var(--color-text-figjam)",
    "textFigjamPressed": "var(--color-text-figjam-pressed)",
    "textFigjamSecondary": "var(--color-text-figjam-secondary)",
    "textFigjamTertiary": "var(--color-text-figjam-tertiary)",
    "textFs": "var(--color-text-fs)",
    "textFsAssistive": "var(--color-text-fs-assistive)",
    "textFsComponent": "var(--color-text-fs-component)",
    "textFsDesign": "var(--color-text-fs-design)",
    "textFsMeasure": "var(--color-text-fs-measure)",
    "textFsOnassistive": "var(--color-text-fs-onassistive)",
    "textFsOncomponent": "var(--color-text-fs-oncomponent)",
    "textFsOndesign": "var(--color-text-fs-ondesign)",
    "textFsOnmeasure": "var(--color-text-fs-onmeasure)",
    "textFsOnselected": "var(--color-text-fs-onselected)",
    "textFsOntemplate": "var(--color-text-fs-ontemplate)",
    "textFsSecondary": "var(--color-text-fs-secondary)",
    "textFsSelected": "var(--color-text-fs-selected)",
    "textFsTemplate": "var(--color-text-fs-template)",
    "textFsTertiary": "var(--color-text-fs-tertiary)",
    "textHandoff": "var(--color-text-handoff)",
    "textHandoffSecondary": "var(--color-text-handoff-secondary)",
    "textHandoffTertiary": "var(--color-text-handoff-tertiary)",
    "textHover": "var(--color-text-hover)",
    "textLink": "var(--color-text-link)",
    "textMeasure": "var(--color-text-measure)",
    "textMeasureSecondary": "var(--color-text-measure-secondary)",
    "textMeasureTertiary": "var(--color-text-measure-tertiary)",
    "textMenu": "var(--color-text-menu)",
    "textMenuDanger": "var(--color-text-menu-danger)",
    "textMenuDisabled": "var(--color-text-menu-disabled)",
    "textMenuHover": "var(--color-text-menu-hover)",
    "textMenuOndisabled": "var(--color-text-menu-ondisabled)",
    "textMenuOnselected": "var(--color-text-menu-onselected)",
    "textMenuSecondary": "var(--color-text-menu-secondary)",
    "textMenuSecondaryHover": "var(--color-text-menu-secondary-hover)",
    "textMenuSelected": "var(--color-text-menu-selected)",
    "textMenuSelectedSecondary": "var(--color-text-menu-selected-secondary)",
    "textMenuSelectedTertiary": "var(--color-text-menu-selected-tertiary)",
    "textMenuTertiary": "var(--color-text-menu-tertiary)",
    "textMenuTertiaryHover": "var(--color-text-menu-tertiary-hover)",
    "textMenuWarning": "var(--color-text-menu-warning)",
    "textOnassistive": "var(--color-text-onassistive)",
    "textOnassistiveSecondary": "var(--color-text-onassistive-secondary)",
    "textOnassistiveTertiary": "var(--color-text-onassistive-tertiary)",
    "textOnbrand": "var(--color-text-onbrand)",
    "textOnbrandSecondary": "var(--color-text-onbrand-secondary)",
    "textOnbrandTertiary": "var(--color-text-onbrand-tertiary)",
    "textOncomponent": "var(--color-text-oncomponent)",
    "textOncomponentSecondary": "var(--color-text-oncomponent-secondary)",
    "textOncomponentTertiary": "var(--color-text-oncomponent-tertiary)",
    "textOndanger": "var(--color-text-ondanger)",
    "textOndangerSecondary": "var(--color-text-ondanger-secondary)",
    "textOndangerTertiary": "var(--color-text-ondanger-tertiary)",
    "textOndesign": "var(--color-text-ondesign)",
    "textOndesignSecondary": "var(--color-text-ondesign-secondary)",
    "textOndesignTertiary": "var(--color-text-ondesign-tertiary)",
    "textOndisabled": "var(--color-text-ondisabled)",
    "textOnfigjam": "var(--color-text-onfigjam)",
    "textOnfigjamSecondary": "var(--color-text-onfigjam-secondary)",
    "textOnfigjamTertiary": "var(--color-text-onfigjam-tertiary)",
    "textOninverse": "var(--color-text-oninverse)",
    "textOninverseSecondary": "var(--color-text-oninverse-secondary)",
    "textOnmeasure": "var(--color-text-onmeasure)",
    "textOnmeasureSecondary": "var(--color-text-onmeasure-secondary)",
    "textOnmeasureTertiary": "var(--color-text-onmeasure-tertiary)",
    "textOnselected": "var(--color-text-onselected)",
    "textOnselectedSecondary": "var(--color-text-onselected-secondary)",
    "textOnselectedStrong": "var(--color-text-onselected-strong)",
    "textOnselectedTertiary": "var(--color-text-onselected-tertiary)",
    "textOnsuccess": "var(--color-text-onsuccess)",
    "textOnsuccessSecondary": "var(--color-text-onsuccess-secondary)",
    "textOnsuccessTertiary": "var(--color-text-onsuccess-tertiary)",
    "textOntemplate": "var(--color-text-ontemplate)",
    "textOnwarning": "var(--color-text-onwarning)",
    "textOnwarningSecondary": "var(--color-text-onwarning-secondary)",
    "textOnwarningTertiary": "var(--color-text-onwarning-tertiary)",
    "textSecondary": "var(--color-text-secondary)",
    "textSecondaryHover": "var(--color-text-secondary-hover)",
    "textSelected": "var(--color-text-selected)",
    "textSelectedSecondary": "var(--color-text-selected-secondary)",
    "textSelectedTertiary": "var(--color-text-selected-tertiary)",
    "textSuccess": "var(--color-text-success)",
    "textSuccessSecondary": "var(--color-text-success-secondary)",
    "textSuccessTertiary": "var(--color-text-success-tertiary)",
    "textTemplate": "var(--color-text-template)",
    "textTemplateSecondary": "var(--color-text-template-secondary)",
    "textTertiary": "var(--color-text-tertiary)",
    "textTertiaryHover": "var(--color-text-tertiary-hover)",
    "textToolbar": "var(--color-text-toolbar)",
    "textToolbarDanger": "var(--color-text-toolbar-danger)",
    "textToolbarDisabled": "var(--color-text-toolbar-disabled)",
    "textToolbarHover": "var(--color-text-toolbar-hover)",
    "textToolbarOndisabled": "var(--color-text-toolbar-ondisabled)",
    "textToolbarOnselected": "var(--color-text-toolbar-onselected)",
    "textToolbarSecondary": "var(--color-text-toolbar-secondary)",
    "textToolbarSecondaryHover": "var(--color-text-toolbar-secondary-hover)",
    "textToolbarSelected": "var(--color-text-toolbar-selected)",
    "textToolbarSelectedSecondary": "var(--color-text-toolbar-selected-secondary)",
    "textToolbarSelectedTertiary": "var(--color-text-toolbar-selected-tertiary)",
    "textToolbarTertiary": "var(--color-text-toolbar-tertiary)",
    "textToolbarTertiaryHover": "var(--color-text-toolbar-tertiary-hover)",
    "textToolbarWarning": "var(--color-text-toolbar-warning)",
    "textTooltip": "var(--color-text-tooltip)",
    "textTooltipDanger": "var(--color-text-tooltip-danger)",
    "textTooltipDisabled": "var(--color-text-tooltip-disabled)",
    "textTooltipHover": "var(--color-text-tooltip-hover)",
    "textTooltipOndisabled": "var(--color-text-tooltip-ondisabled)",
    "textTooltipOnselected": "var(--color-text-tooltip-onselected)",
    "textTooltipSecondary": "var(--color-text-tooltip-secondary)",
    "textTooltipSecondaryHover": "var(--color-text-tooltip-secondary-hover)",
    "textTooltipSelected": "var(--color-text-tooltip-selected)",
    "textTooltipSelectedSecondary": "var(--color-text-tooltip-selected-secondary)",
    "textTooltipSelectedTertiary": "var(--color-text-tooltip-selected-tertiary)",
    "textTooltipTertiary": "var(--color-text-tooltip-tertiary)",
    "textTooltipTertiaryHover": "var(--color-text-tooltip-tertiary-hover)",
    "textTooltipWarning": "var(--color-text-tooltip-warning)",
    "textWarning": "var(--color-text-warning)",
    "textWarningSecondary": "var(--color-text-warning-secondary)",
    "textWarningTertiary": "var(--color-text-warning-tertiary)",
    "texthighlight": "var(--color-texthighlight)",
    "textondarkannotation": "var(--color-textondarkannotation)",
    "textondarkcanvas": "var(--color-textondarkcanvas)",
    "textondarkcanvassecondary": "var(--color-textondarkcanvassecondary)",
    "textoninspectpadding": "var(--color-textoninspectpadding)",
    "textoninspectspacing": "var(--color-textoninspectspacing)",
    "textonlightannotation": "var(--color-textonlightannotation)",
    "textonlightcanvas": "var(--color-textonlightcanvas)",
    "textonlightcanvassecondary": "var(--color-textonlightcanvassecondary)",
    "textonmultiplayerblue": "var(--color-textonmultiplayerblue)",
    "textonmultiplayergreen": "var(--color-textonmultiplayergreen)",
    "textonmultiplayergrey": "var(--color-textonmultiplayergrey)",
    "textonmultiplayerpink": "var(--color-textonmultiplayerpink)",
    "textonmultiplayerpurple": "var(--color-textonmultiplayerpurple)",
    "textonmultiplayerred": "var(--color-textonmultiplayerred)",
    "textonmultiplayeryellow": "var(--color-textonmultiplayeryellow)",
    "textonvoting": "var(--color-textonvoting)",
    "timelinenodedefault": "var(--color-timelinenodedefault)",
    "timelinenodedefaulthover": "var(--color-timelinenodedefaulthover)"
  },
  "duration": {
    "lg": "var(--duration-lg)",
    "md": "var(--duration-md)",
    "none": "var(--duration-none)",
    "sm": "var(--duration-sm)"
  },
  "elevation": {
    "x100": "var(--elevation-100)",
    "x200": "var(--elevation-200)",
    "x300": "var(--elevation-300)",
    "x400": "var(--elevation-400)",
    "x500": "var(--elevation-500)",
    "x100DropShadow": "var(--elevation-100-drop-shadow)",
    "x200DropShadow": "var(--elevation-200-drop-shadow)",
    "x300DropShadow": "var(--elevation-300-drop-shadow)",
    "x400DropShadow": "var(--elevation-400-drop-shadow)",
    "x500DropShadow": "var(--elevation-500-drop-shadow)"
  },
  "font": {
    "family": {
      "default": "var(--font-family-default)",
      "display": "var(--font-family-display)",
      "mono": "var(--font-family-mono)"
    },
    "weight": {
      "default": "var(--font-weight-default)",
      "strong": "var(--font-weight-strong)"
    }
  },
  "radius": {
    "full": "var(--radius-full)",
    "large": "var(--radius-large)",
    "medium": "var(--radius-medium)",
    "none": "var(--radius-none)",
    "small": "var(--radius-small)"
  },
  "ramp": {
    "black100": "var(--ramp-black-100)",
    "black200": "var(--ramp-black-200)",
    "black300": "var(--ramp-black-300)",
    "black400": "var(--ramp-black-400)",
    "black500": "var(--ramp-black-500)",
    "black600": "var(--ramp-black-600)",
    "black700": "var(--ramp-black-700)",
    "black800": "var(--ramp-black-800)",
    "black900": "var(--ramp-black-900)",
    "black1000": "var(--ramp-black-1000)",
    "blue100": "var(--ramp-blue-100)",
    "blue200": "var(--ramp-blue-200)",
    "blue300": "var(--ramp-blue-300)",
    "blue400": "var(--ramp-blue-400)",
    "blue500": "var(--ramp-blue-500)",
    "blue600": "var(--ramp-blue-600)",
    "blue700": "var(--ramp-blue-700)",
    "blue800": "var(--ramp-blue-800)",
    "blue900": "var(--ramp-blue-900)",
    "blue1000": "var(--ramp-blue-1000)",
    "green100": "var(--ramp-green-100)",
    "green200": "var(--ramp-green-200)",
    "green300": "var(--ramp-green-300)",
    "green400": "var(--ramp-green-400)",
    "green500": "var(--ramp-green-500)",
    "green600": "var(--ramp-green-600)",
    "green700": "var(--ramp-green-700)",
    "green800": "var(--ramp-green-800)",
    "green900": "var(--ramp-green-900)",
    "green1000": "var(--ramp-green-1000)",
    "grey100": "var(--ramp-grey-100)",
    "grey200": "var(--ramp-grey-200)",
    "grey300": "var(--ramp-grey-300)",
    "grey400": "var(--ramp-grey-400)",
    "grey500": "var(--ramp-grey-500)",
    "grey600": "var(--ramp-grey-600)",
    "grey700": "var(--ramp-grey-700)",
    "grey800": "var(--ramp-grey-800)",
    "grey900": "var(--ramp-grey-900)",
    "grey1000": "var(--ramp-grey-1000)",
    "lime100": "var(--ramp-lime-100)",
    "lime200": "var(--ramp-lime-200)",
    "lime300": "var(--ramp-lime-300)",
    "lime400": "var(--ramp-lime-400)",
    "lime500": "var(--ramp-lime-500)",
    "lime600": "var(--ramp-lime-600)",
    "lime700": "var(--ramp-lime-700)",
    "lime800": "var(--ramp-lime-800)",
    "lime900": "var(--ramp-lime-900)",
    "lime1000": "var(--ramp-lime-1000)",
    "orange100": "var(--ramp-orange-100)",
    "orange200": "var(--ramp-orange-200)",
    "orange300": "var(--ramp-orange-300)",
    "orange400": "var(--ramp-orange-400)",
    "orange500": "var(--ramp-orange-500)",
    "orange600": "var(--ramp-orange-600)",
    "orange700": "var(--ramp-orange-700)",
    "orange800": "var(--ramp-orange-800)",
    "orange900": "var(--ramp-orange-900)",
    "orange1000": "var(--ramp-orange-1000)",
    "paleBlue100": "var(--ramp-pale-blue-100)",
    "paleBlue200": "var(--ramp-pale-blue-200)",
    "paleBlue300": "var(--ramp-pale-blue-300)",
    "paleBlue400": "var(--ramp-pale-blue-400)",
    "paleBlue500": "var(--ramp-pale-blue-500)",
    "paleBlue600": "var(--ramp-pale-blue-600)",
    "paleBlue700": "var(--ramp-pale-blue-700)",
    "paleBlue800": "var(--ramp-pale-blue-800)",
    "paleBlue850": "var(--ramp-pale-blue-850)",
    "paleBlue900": "var(--ramp-pale-blue-900)",
    "paleBlue1000": "var(--ramp-pale-blue-1000)",
    "paleGreen100": "var(--ramp-pale-green-100)",
    "paleGreen200": "var(--ramp-pale-green-200)",
    "paleGreen300": "var(--ramp-pale-green-300)",
    "paleGreen400": "var(--ramp-pale-green-400)",
    "paleGreen500": "var(--ramp-pale-green-500)",
    "paleGreen600": "var(--ramp-pale-green-600)",
    "paleGreen700": "var(--ramp-pale-green-700)",
    "paleGreen800": "var(--ramp-pale-green-800)",
    "paleGreen900": "var(--ramp-pale-green-900)",
    "paleGreen1000": "var(--ramp-pale-green-1000)",
    "paleLime100": "var(--ramp-pale-lime-100)",
    "paleLime200": "var(--ramp-pale-lime-200)",
    "paleLime300": "var(--ramp-pale-lime-300)",
    "paleLime400": "var(--ramp-pale-lime-400)",
    "paleLime500": "var(--ramp-pale-lime-500)",
    "paleLime600": "var(--ramp-pale-lime-600)",
    "paleLime700": "var(--ramp-pale-lime-700)",
    "paleLime800": "var(--ramp-pale-lime-800)",
    "paleLime900": "var(--ramp-pale-lime-900)",
    "paleLime1000": "var(--ramp-pale-lime-1000)",
    "palePersimmon100": "var(--ramp-pale-persimmon-100)",
    "palePersimmon200": "var(--ramp-pale-persimmon-200)",
    "palePersimmon300": "var(--ramp-pale-persimmon-300)",
    "palePersimmon400": "var(--ramp-pale-persimmon-400)",
    "palePersimmon500": "var(--ramp-pale-persimmon-500)",
    "palePersimmon600": "var(--ramp-pale-persimmon-600)",
    "palePersimmon700": "var(--ramp-pale-persimmon-700)",
    "palePersimmon800": "var(--ramp-pale-persimmon-800)",
    "palePersimmon900": "var(--ramp-pale-persimmon-900)",
    "palePersimmon1000": "var(--ramp-pale-persimmon-1000)",
    "palePink100": "var(--ramp-pale-pink-100)",
    "palePink200": "var(--ramp-pale-pink-200)",
    "palePink300": "var(--ramp-pale-pink-300)",
    "palePink400": "var(--ramp-pale-pink-400)",
    "palePink500": "var(--ramp-pale-pink-500)",
    "palePink600": "var(--ramp-pale-pink-600)",
    "palePink700": "var(--ramp-pale-pink-700)",
    "palePink800": "var(--ramp-pale-pink-800)",
    "palePink900": "var(--ramp-pale-pink-900)",
    "palePink1000": "var(--ramp-pale-pink-1000)",
    "palePurple100": "var(--ramp-pale-purple-100)",
    "palePurple200": "var(--ramp-pale-purple-200)",
    "palePurple300": "var(--ramp-pale-purple-300)",
    "palePurple400": "var(--ramp-pale-purple-400)",
    "palePurple450": "var(--ramp-pale-purple-450)",
    "palePurple500": "var(--ramp-pale-purple-500)",
    "palePurple600": "var(--ramp-pale-purple-600)",
    "palePurple700": "var(--ramp-pale-purple-700)",
    "palePurple800": "var(--ramp-pale-purple-800)",
    "palePurple900": "var(--ramp-pale-purple-900)",
    "palePurple1000": "var(--ramp-pale-purple-1000)",
    "paleRed100": "var(--ramp-pale-red-100)",
    "paleRed200": "var(--ramp-pale-red-200)",
    "paleRed300": "var(--ramp-pale-red-300)",
    "paleRed400": "var(--ramp-pale-red-400)",
    "paleRed500": "var(--ramp-pale-red-500)",
    "paleRed600": "var(--ramp-pale-red-600)",
    "paleRed700": "var(--ramp-pale-red-700)",
    "paleRed800": "var(--ramp-pale-red-800)",
    "paleRed900": "var(--ramp-pale-red-900)",
    "paleRed1000": "var(--ramp-pale-red-1000)",
    "paleTeal100": "var(--ramp-pale-teal-100)",
    "paleTeal200": "var(--ramp-pale-teal-200)",
    "paleTeal300": "var(--ramp-pale-teal-300)",
    "paleTeal400": "var(--ramp-pale-teal-400)",
    "paleTeal500": "var(--ramp-pale-teal-500)",
    "paleTeal600": "var(--ramp-pale-teal-600)",
    "paleTeal700": "var(--ramp-pale-teal-700)",
    "paleTeal800": "var(--ramp-pale-teal-800)",
    "paleTeal900": "var(--ramp-pale-teal-900)",
    "paleTeal1000": "var(--ramp-pale-teal-1000)",
    "paleViolet100": "var(--ramp-pale-violet-100)",
    "paleViolet200": "var(--ramp-pale-violet-200)",
    "paleViolet300": "var(--ramp-pale-violet-300)",
    "paleViolet400": "var(--ramp-pale-violet-400)",
    "paleViolet500": "var(--ramp-pale-violet-500)",
    "paleViolet600": "var(--ramp-pale-violet-600)",
    "paleViolet700": "var(--ramp-pale-violet-700)",
    "paleViolet800": "var(--ramp-pale-violet-800)",
    "paleViolet900": "var(--ramp-pale-violet-900)",
    "paleViolet1000": "var(--ramp-pale-violet-1000)",
    "paleYellow100": "var(--ramp-pale-yellow-100)",
    "paleYellow200": "var(--ramp-pale-yellow-200)",
    "paleYellow300": "var(--ramp-pale-yellow-300)",
    "paleYellow400": "var(--ramp-pale-yellow-400)",
    "paleYellow500": "var(--ramp-pale-yellow-500)",
    "paleYellow600": "var(--ramp-pale-yellow-600)",
    "paleYellow700": "var(--ramp-pale-yellow-700)",
    "paleYellow800": "var(--ramp-pale-yellow-800)",
    "paleYellow900": "var(--ramp-pale-yellow-900)",
    "paleYellow1000": "var(--ramp-pale-yellow-1000)",
    "persimmon100": "var(--ramp-persimmon-100)",
    "persimmon200": "var(--ramp-persimmon-200)",
    "persimmon300": "var(--ramp-persimmon-300)",
    "persimmon400": "var(--ramp-persimmon-400)",
    "persimmon500": "var(--ramp-persimmon-500)",
    "persimmon600": "var(--ramp-persimmon-600)",
    "persimmon700": "var(--ramp-persimmon-700)",
    "persimmon800": "var(--ramp-persimmon-800)",
    "persimmon900": "var(--ramp-persimmon-900)",
    "persimmon1000": "var(--ramp-persimmon-1000)",
    "pink100": "var(--ramp-pink-100)",
    "pink200": "var(--ramp-pink-200)",
    "pink300": "var(--ramp-pink-300)",
    "pink400": "var(--ramp-pink-400)",
    "pink500": "var(--ramp-pink-500)",
    "pink600": "var(--ramp-pink-600)",
    "pink700": "var(--ramp-pink-700)",
    "pink800": "var(--ramp-pink-800)",
    "pink900": "var(--ramp-pink-900)",
    "pink1000": "var(--ramp-pink-1000)",
    "purple100": "var(--ramp-purple-100)",
    "purple200": "var(--ramp-purple-200)",
    "purple300": "var(--ramp-purple-300)",
    "purple400": "var(--ramp-purple-400)",
    "purple450": "var(--ramp-purple-450)",
    "purple500": "var(--ramp-purple-500)",
    "purple600": "var(--ramp-purple-600)",
    "purple700": "var(--ramp-purple-700)",
    "purple800": "var(--ramp-purple-800)",
    "purple900": "var(--ramp-purple-900)",
    "purple1000": "var(--ramp-purple-1000)",
    "red100": "var(--ramp-red-100)",
    "red200": "var(--ramp-red-200)",
    "red300": "var(--ramp-red-300)",
    "red400": "var(--ramp-red-400)",
    "red500": "var(--ramp-red-500)",
    "red600": "var(--ramp-red-600)",
    "red700": "var(--ramp-red-700)",
    "red800": "var(--ramp-red-800)",
    "red900": "var(--ramp-red-900)",
    "red1000": "var(--ramp-red-1000)",
    "teal100": "var(--ramp-teal-100)",
    "teal200": "var(--ramp-teal-200)",
    "teal300": "var(--ramp-teal-300)",
    "teal400": "var(--ramp-teal-400)",
    "teal500": "var(--ramp-teal-500)",
    "teal600": "var(--ramp-teal-600)",
    "teal700": "var(--ramp-teal-700)",
    "teal800": "var(--ramp-teal-800)",
    "teal900": "var(--ramp-teal-900)",
    "teal1000": "var(--ramp-teal-1000)",
    "violet100": "var(--ramp-violet-100)",
    "violet200": "var(--ramp-violet-200)",
    "violet300": "var(--ramp-violet-300)",
    "violet400": "var(--ramp-violet-400)",
    "violet500": "var(--ramp-violet-500)",
    "violet600": "var(--ramp-violet-600)",
    "violet700": "var(--ramp-violet-700)",
    "violet800": "var(--ramp-violet-800)",
    "violet900": "var(--ramp-violet-900)",
    "violet1000": "var(--ramp-violet-1000)",
    "white100": "var(--ramp-white-100)",
    "white200": "var(--ramp-white-200)",
    "white300": "var(--ramp-white-300)",
    "white400": "var(--ramp-white-400)",
    "white500": "var(--ramp-white-500)",
    "white600": "var(--ramp-white-600)",
    "white700": "var(--ramp-white-700)",
    "white800": "var(--ramp-white-800)",
    "white900": "var(--ramp-white-900)",
    "white1000": "var(--ramp-white-1000)",
    "yellow100": "var(--ramp-yellow-100)",
    "yellow200": "var(--ramp-yellow-200)",
    "yellow300": "var(--ramp-yellow-300)",
    "yellow400": "var(--ramp-yellow-400)",
    "yellow500": "var(--ramp-yellow-500)",
    "yellow600": "var(--ramp-yellow-600)",
    "yellow700": "var(--ramp-yellow-700)",
    "yellow800": "var(--ramp-yellow-800)",
    "yellow900": "var(--ramp-yellow-900)",
    "yellow1000": "var(--ramp-yellow-1000)"
  },
  "spacer": {
    "x0": "var(--spacer-0)",
    "x0px": "var(--spacer-0px)",
    "x1": "var(--spacer-1)",
    "x2": "var(--spacer-2)",
    "x25": "var(--spacer-2-5)",
    "x3": "var(--spacer-3)",
    "x4": "var(--spacer-4)",
    "x4px": "var(--spacer-4px)",
    "x5": "var(--spacer-5)",
    "x6": "var(--spacer-6)",
    "x8px": "var(--spacer-8px)",
    "x12px": "var(--spacer-12px)",
    "x16px": "var(--spacer-16px)",
    "x24px": "var(--spacer-24px)",
    "x32px": "var(--spacer-32px)",
    "x40px": "var(--spacer-40px)"
  },
  "textDecorationColor": {
    "link": "var(--text-decoration-color-link)"
  },
  "textDecoration": {
    "link": "var(--text-decoration-link)"
  },
  "textUnderlineOffset": {
    "link": "var(--text-underline-offset-link)"
  },
  "text": {
    "body": {
      "large": {
        "fontFamily": "var(--text-body-large-font-family)",
        "fontSize": "var(--text-body-large-font-size)",
        "fontWeight": "var(--text-body-large-font-weight)",
        "lineHeight": "var(--text-body-large-line-height)",
        "letterSpacing": "var(--text-body-large-letter-spacing)"
      },
      "largeStrong": {
        "fontFamily": "var(--text-body-large-strong-font-family)",
        "fontSize": "var(--text-body-large-strong-font-size)",
        "fontWeight": "var(--text-body-large-strong-font-weight)",
        "lineHeight": "var(--text-body-large-strong-line-height)",
        "letterSpacing": "var(--text-body-large-strong-letter-spacing)"
      },
      "medium": {
        "fontFamily": "var(--text-body-medium-font-family)",
        "fontSize": "var(--text-body-medium-font-size)",
        "fontWeight": "var(--text-body-medium-font-weight)",
        "lineHeight": "var(--text-body-medium-line-height)",
        "letterSpacing": "var(--text-body-medium-letter-spacing)"
      },
      "mediumStrong": {
        "fontFamily": "var(--text-body-medium-strong-font-family)",
        "fontSize": "var(--text-body-medium-strong-font-size)",
        "fontWeight": "var(--text-body-medium-strong-font-weight)",
        "lineHeight": "var(--text-body-medium-strong-line-height)",
        "letterSpacing": "var(--text-body-medium-strong-letter-spacing)"
      },
      "small": {
        "fontFamily": "var(--text-body-small-font-family)",
        "fontSize": "var(--text-body-small-font-size)",
        "fontWeight": "var(--text-body-small-font-weight)",
        "lineHeight": "var(--text-body-small-line-height)",
        "letterSpacing": "var(--text-body-small-letter-spacing)"
      },
      "smallStrong": {
        "fontFamily": "var(--text-body-small-strong-font-family)",
        "fontSize": "var(--text-body-small-strong-font-size)",
        "fontWeight": "var(--text-body-small-strong-font-weight)",
        "lineHeight": "var(--text-body-small-strong-line-height)",
        "letterSpacing": "var(--text-body-small-strong-letter-spacing)"
      }
    },
    "display": {
      "fontFamily": "var(--text-display-font-family)",
      "fontSize": "var(--text-display-font-size)",
      "fontWeight": "var(--text-display-font-weight)",
      "lineHeight": "var(--text-display-line-height)",
      "letterSpacing": "var(--text-display-letter-spacing)"
    },
    "heading": {
      "large": {
        "fontFamily": "var(--text-heading-large-font-family)",
        "fontSize": "var(--text-heading-large-font-size)",
        "fontWeight": "var(--text-heading-large-font-weight)",
        "lineHeight": "var(--text-heading-large-line-height)",
        "letterSpacing": "var(--text-heading-large-letter-spacing)"
      },
      "medium": {
        "fontFamily": "var(--text-heading-medium-font-family)",
        "fontSize": "var(--text-heading-medium-font-size)",
        "fontWeight": "var(--text-heading-medium-font-weight)",
        "lineHeight": "var(--text-heading-medium-line-height)",
        "letterSpacing": "var(--text-heading-medium-letter-spacing)"
      },
      "small": {
        "fontFamily": "var(--text-heading-small-font-family)",
        "fontSize": "var(--text-heading-small-font-size)",
        "fontWeight": "var(--text-heading-small-font-weight)",
        "lineHeight": "var(--text-heading-small-line-height)",
        "letterSpacing": "var(--text-heading-small-letter-spacing)"
      }
    },
    "mono": {
      "large": {
        "fontFamily": "var(--text-mono-large-font-family)",
        "fontSize": "var(--text-mono-large-font-size)",
        "fontWeight": "var(--text-mono-large-font-weight)",
        "lineHeight": "var(--text-mono-large-line-height)",
        "letterSpacing": "var(--text-mono-large-letter-spacing)"
      },
      "medium": {
        "fontFamily": "var(--text-mono-medium-font-family)",
        "fontSize": "var(--text-mono-medium-font-size)",
        "fontWeight": "var(--text-mono-medium-font-weight)",
        "lineHeight": "var(--text-mono-medium-line-height)",
        "letterSpacing": "var(--text-mono-medium-letter-spacing)"
      },
      "small": {
        "fontFamily": "var(--text-mono-small-font-family)",
        "fontSize": "var(--text-mono-small-font-size)",
        "fontWeight": "var(--text-mono-small-font-weight)",
        "lineHeight": "var(--text-mono-small-line-height)",
        "letterSpacing": "var(--text-mono-small-letter-spacing)"
      }
    }
  },
  "zIndex": {
    "assistant": "var(--z-index-assistant)",
    "canvas": {
      "base": "var(--z-index-canvas-base)",
      "modifiers": "var(--z-index-canvas-modifiers)",
      "pin": "var(--z-index-canvas-pin)",
      "pinActive": "var(--z-index-canvas-pin-active)"
    },
    "contextEditing": "var(--z-index-context-editing)",
    "cursor": {
      "multiplayer": "var(--z-index-cursor-multiplayer)",
      "multiplayerEmote": "var(--z-index-cursor-multiplayer-emote)",
      "user": "var(--z-index-cursor-user)",
      "userEmote": "var(--z-index-cursor-user-emote)"
    },
    "dropdown": "var(--z-index-dropdown)",
    "modal": "var(--z-index-modal)",
    "nav": "var(--z-index-nav)",
    "scrubCursor": "var(--z-index-scrub-cursor)",
    "sidebar": "var(--z-index-sidebar)",
    "toolbarWidgets": "var(--z-index-toolbar-widgets)",
    "tooltip": "var(--z-index-tooltip)",
    "visualBell": "var(--z-index-visual-bell)",
    "window": "var(--z-index-window)"
  }
}
